<template>
  <div>
    <v-row no-gutters class="d-none d-md-flex justify-space-around">
      <v-col>
        <autocomplete-staff
          v-model="name"
          item-text=""
          item-value=""
          label="Họ tên"
          filled
          clearable
          single-line
          dense
        ></autocomplete-staff>
      </v-col>

      <v-col>
        <v-autocomplete
          v-model="status"
          :items="statusList"
          small-chips
          clear-icon="mdi-close"
          clearable
          deletable-chips
          label="Trạng Thái"
          filled
          single-line
          dense
        ></v-autocomplete>
      </v-col>

      <v-col>
        <v-btn
          dark
          color="#FFB300"
          depressed
          @click="onFilterChanged"
          class="py-5"
        >
          <v-icon left>mdi-filter-outline</v-icon>Lọc
        </v-btn>
      </v-col>
    </v-row>
    <div class="d-flex d-md-none justify-end">
      <v-btn icon @click="filterState = !filterState">
        <v-icon right>mdi-filter</v-icon>
      </v-btn>
      <staff-filter-dialog
        @onFilterChanged="onFilterDialogChanged"
        :state="filterState"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AutocompleteStaff from '@/components/basic/input/AutocompleteStaff'
import StaffFilterDialog from '@/modules/staff/StaffFilterDialog'

export default {
  components: {
    AutocompleteStaff,
    StaffFilterDialog
  },
  data: () => ({
    name: '',
    query: '',
    statusList: ['active', 'block'],
    status: [],
    selectedRole: [],
    filterState: false
  }),
  computed: {
    ...mapGetters('app', ['users', 'roles']),
    roleList() {
      return this.roles.filter(role => {
        return role.type !== 'student' && role.type !== 'public'
      })
    }
  },
  methods: {
    ...mapActions('staff', ['updateStudent']),
    onFilterChanged() {
      this.query = this.name
        ? 'name_in=' + this.name + '&'
        : '' + this.status
          ? this.status
            .map(item => {
              return 'status_in=' + item
            })
            .join('&')
          : ''
      this.$emit('onFilterChanged', this.query)
    },
    onFilterDialogChanged(data) {
      this.query = data.name
        ? 'name_in=' + data.name + '&'
        : '' + data.status
          ? 'status_in=' + data.status
          : ''
      this.$emit('onFilterChanged', this.query)
    }
  }
}
</script>
